import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { ExameConfiance, ExameLaboratorio } from 'app/core/interfaces/pacient-info.interface';
import { logger } from 'app/core/utils/console';
import { resolveLaboratorioDataPadrao } from 'app/shared/laboratorio-data.utils';

@Component({
  selector: 'app-modal-analisar-exame',
  templateUrl: './modal-analisar-exame.component.html',
  styleUrls: ['./modal-analisar-exame.component.scss']
})
export class ModalAnalisarExameComponent implements OnInit {
  isLoading: boolean = false;
  examesAnalisados: ExameConfiance[] = [];
  examesLaboratoriosList: ExameLaboratorio[] = [];
  examesLaboratoriosBackup: ExameLaboratorio[] = [];
  errorMessage: string = '';
  showSemestreSelection: boolean = false;
  selectedSemestre: number = 1;
  arquivoId: string = '';
  dataRealizacaoArquivo: string | Date | any = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      formData?: FormData,
      cartaoId: string,
      initialTrimestre?: number,
      examesLaboratorios: ExameLaboratorio[],
      dum?: string | Date,
      preAnalisedExams?: ExameConfiance[],
      preAnalisedArquivoId?: string,
      preAnalisedDataRealizacao?: string | Date | null
    },
    public dialogRef: MatDialogRef<ModalAnalisarExameComponent>,
    private _apiGestaCard: APIGestaCardService,
    private _changeDetector: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.examesLaboratoriosList = JSON.parse(JSON.stringify(this.data.examesLaboratorios));
    this.examesLaboratoriosBackup = JSON.parse(JSON.stringify(this.data.examesLaboratorios));
    if (this.data.initialTrimestre) {
      this.selectedSemestre = this.data.initialTrimestre;
    }
    if (this.data.preAnalisedExams && this.data.preAnalisedExams.length > 0) {
      this.examesAnalisados = this.data.preAnalisedExams.map(e => ({ ...e, used: false }));
      this.arquivoId = this.data.preAnalisedArquivoId || '';
      this.dataRealizacaoArquivo = this.data.preAnalisedDataRealizacao || null;
      this.showSemestreSelection = true;
      this.autoAplicarExamesAltaConfianca();
    } else {
      this.analisarExames();
    }
  }

  get temPDFLocal(): boolean {
    return !!(this.data.formData && this.data.formData.get('pdf'));
  }

  abrirPDF(): void {
    if (!this.temPDFLocal) return;
    const leitor = new FileReader();

    leitor.onload = (e: any) => {
      const pdfDataUrl = e.target.result;
      const pdfWindow = window.open('', '_blank');
      if (pdfWindow) {
        pdfWindow.document.write(`
          <html>
            <head>
              <title>Visualizador de PDF</title>
            </head>
            <body style="margin:0">
              <embed width="100%" height="100%" src="${pdfDataUrl}" type="application/pdf">
            </body>
          </html>
        `);
      } else {
        alert('Não foi possível abrir o PDF. Verifique se o bloqueador de pop-ups está desativado.');
      }
    };

    leitor.readAsDataURL(this.data.formData!.get('pdf') as File);
  }

  async analisarExames(): Promise<void> {
    try {
      this.isLoading = true;
      this.errorMessage = '';

      const resultado = await this._apiGestaCard.AnalisarPDFExames(
        this.data.cartaoId,
        this.data.formData!.get('pdf') as File,
        this.selectedSemestre
      );

      this.examesAnalisados = resultado.exames;
      logger.log('resultado:', resultado);
      this.arquivoId = resultado.arquivoId;

      // Para novos uploads, recuperar data_realizacao gravada no arquivo analisado
      if (this.arquivoId) {
        try {
          const arquivo = await this._apiGestaCard.BuscarArquivoPDF(this.arquivoId);
          this.dataRealizacaoArquivo = arquivo && (arquivo as any).data_realizacao
            ? (arquivo as any).data_realizacao
            : null;
        } catch (error) {
          this.dataRealizacaoArquivo = null;
        }
      }
      
      if (this.examesAnalisados.length > 0) {
        this.showSemestreSelection = true;
        this.autoAplicarExamesAltaConfianca();
      }
      
    } catch (error) {
      this.errorMessage = 'Erro ao analisar o PDF. Tente novamente.';
    } finally {
      this.isLoading = false;
    }
  }

  private autoAplicarExamesAltaConfianca(): void {
    this.examesAnalisados.forEach(exameConfiance => {
      if (exameConfiance.confidence >= 90) {
        const exameLab = this.findExameLaboratorioSemCriar(exameConfiance.name);

        const examesUseDescription = ['ABO/RH', 'Plaquetas', 'HT/HB', 'TSH', 'Glicose em Jejum', 'TTOG (GTT)'];
        
        if (exameLab) {
          if (this.searchDescription(exameConfiance) && examesUseDescription.includes(exameConfiance.name)) {
            exameConfiance.used = true;
            this.setResultInSemestre(exameLab, this.searchDescription(exameConfiance));
          } else if (exameConfiance.status) {
            exameConfiance.used = true;
            this.setResultInSemestre(exameLab, exameConfiance.status);
          } 
        }
      }
    });
  }

  findExameLaboratorio(nomeExame: string): ExameLaboratorio | null {
    nomeExame = nomeExame.trim().toLowerCase();

    let exame: ExameLaboratorio | undefined = this.examesLaboratoriosList.find(exame => exame.name.trim().toLowerCase() === nomeExame)

    if (!exame) {
      exame = {
        name: nomeExame,
        datas: {
          res1: null,
          res2: null,
          res3: null,
          data1: null,
          data2: null,
          data3: null,
        },
        data_limite_tri1: null,
        data_limite_tri2: null,
        data_limite_tri3: null,
        arquivo_res1: null,
        arquivo_res2: null,
        arquivo_res3: null,
      };

      this.examesLaboratoriosList.push(exame);
    }
    
    return exame
  }

  private findExameLaboratorioSemCriar(nomeExame: string): ExameLaboratorio | null {
    nomeExame = nomeExame.trim().toLowerCase();

    return this.examesLaboratoriosList.find(exame => exame.name.trim().toLowerCase() === nomeExame) || null;
  }

  hasResultInSemestre(exameLab: ExameLaboratorio): boolean {
    if (!exameLab) return false;
    
    switch (this.selectedSemestre) {
      case 1: return !!exameLab.datas.res1;
      case 2: return !!exameLab.datas.res2;
      case 3: return !!exameLab.datas.res3;
      default: return false;
    }
  }

  usarStatus(exameConfiance: ExameConfiance): void {
    const exameLab = this.findExameLaboratorio(exameConfiance.name);
    if (exameLab) {
      exameConfiance.used = true;
      this.setResultInSemestre(exameLab, exameConfiance.status);
    }
  }

  usarDescription(exameConfiance: ExameConfiance): void {
    const exameLab = this.findExameLaboratorio(exameConfiance.name);
    if (exameLab) {
      exameConfiance.used = true;
      this.setResultInSemestre(exameLab, this.searchDescription(exameConfiance));
    }
  }

  searchDescription(exameConfiance: ExameConfiance): string {
    let result = exameConfiance.description || '';
    if (exameConfiance.result) result = exameConfiance.result;

    return result.replace('Resultado:', '').replace('Resultado/', '').trim();
  }

  private setResultInSemestre(exameLab: ExameLaboratorio, valor: string): void {
    const dataResultado = this.getDataResultadoPadrao();
    
    switch (this.selectedSemestre) {
      case 1:
        exameLab.datas.res1 = valor;
        exameLab.datas.data1 = dataResultado;
        exameLab.arquivo_res1 = this.arquivoId || null;
        break;
      case 2:
        exameLab.datas.res2 = valor;
        exameLab.datas.data2 = dataResultado;
        exameLab.arquivo_res2 = this.arquivoId || null;
        break;
      case 3:
        exameLab.datas.res3 = valor;
        exameLab.datas.data3 = dataResultado;
        exameLab.arquivo_res3 = this.arquivoId || null;
        break;
    }
  }

  private getDataResultadoPadrao(): string {
    return resolveLaboratorioDataPadrao(this.dataRealizacaoArquivo, this.examesAnalisados);
  }

  private applyDataSomenteNosExamesDoArquivoAtual(data: string): void {
    if (!data || !this.arquivoId) return;

    this.examesLaboratoriosList.forEach((exameLab) => {
      if (!exameLab || !exameLab.datas) return;

      switch (this.selectedSemestre) {
        case 1:
          if (exameLab.arquivo_res1 === this.arquivoId) {
            exameLab.datas.data1 = data;
          }
          break;
        case 2:
          if (exameLab.arquivo_res2 === this.arquivoId) {
            exameLab.datas.data2 = data;
          }
          break;
        case 3:
          if (exameLab.arquivo_res3 === this.arquivoId) {
            exameLab.datas.data3 = data;
          }
          break;
      }
    });
  }

  descartarDados(): void {
    this.dialogRef.close({ action: 'discard' });
  }

  finalizarEdicao(): void {
    const dataTrimestre = this.getDataResultadoPadrao();
    this.applyDataSomenteNosExamesDoArquivoAtual(dataTrimestre);

    this.dialogRef.close({ 
      action: 'save', 
      arquivoId: this.arquivoId,
      examesLaboratorios: this.examesLaboratoriosList,
      semestre: this.selectedSemestre
    });
  }

  getResultInSemestre(exameLab: ExameLaboratorio): string {
    if (!exameLab) return '';
    
    switch (this.selectedSemestre) {
      case 1: return exameLab.datas.res1 || '';
      case 2: return exameLab.datas.res2 || '';
      case 3: return exameLab.datas.res3 || '';
      default: return '';
    }
  }

  isStatusUsed(exameConfiance: ExameConfiance): boolean {
    const exameLab = this.findExameLaboratorioSemCriar(exameConfiance.name);
    if (!exameLab) return false;
    
    const currentResult = this.getResultInSemestre(exameLab);
    return currentResult === exameConfiance.status;
  }

  isDescriptionUsed(exameConfiance: ExameConfiance): boolean {
    const exameLab = this.findExameLaboratorioSemCriar(exameConfiance.name);
    if (!exameLab) return false;
    
    const currentResult = this.getResultInSemestre(exameLab);
    const description = this.searchDescription(exameConfiance);
    return currentResult === description;
  }

  pararDeUsar(exameConfiance: ExameConfiance): void {
    const exameLab = this.findExameLaboratorioSemCriar(exameConfiance.name);
    const exameBackup = this.findExameInBackup(exameConfiance.name);

    exameConfiance.used = false;
    
    if (exameLab) {
      switch (this.selectedSemestre) {
        case 1:
          exameLab.datas.res1 = exameBackup && exameBackup.datas.res1 ? exameBackup.datas.res1 : null;
          exameLab.datas.data1 = exameBackup && exameBackup.datas.data1 ? exameBackup.datas.data1 : null;
          exameLab.arquivo_res1 = exameBackup ? exameBackup.arquivo_res1 : null;
          break;
        case 2:
          exameLab.datas.res2 = exameBackup && exameBackup.datas.res2 ? exameBackup.datas.res2 : null;
          exameLab.datas.data2 = exameBackup && exameBackup.datas.data2 ? exameBackup.datas.data2 : null;
          exameLab.arquivo_res2 = exameBackup ? exameBackup.arquivo_res2 : null;
          break;
        case 3:
          exameLab.datas.res3 = exameBackup && exameBackup.datas.res3 ? exameBackup.datas.res3 : null;
          exameLab.datas.data3 = exameBackup && exameBackup.datas.data3 ? exameBackup.datas.data3 : null;
          exameLab.arquivo_res3 = exameBackup ? exameBackup.arquivo_res3 : null;
          break;
      }
      
      this._changeDetector.detectChanges();
    }
  }

  pararDeUsarPorNome(nomeExame: string): void {
    nomeExame = nomeExame.trim().toLowerCase();
 
    const exameConfiance = this.examesAnalisados.find(e => e.name.trim().toLowerCase() === nomeExame);

    if (exameConfiance) {
      this.pararDeUsar(exameConfiance);
    }
  }

  private findExameInBackup(nomeExame: string): ExameLaboratorio | null {
    return this.examesLaboratoriosBackup.find(exame => exame.name === nomeExame) || null;
  }

}

